var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "IconLinkItem",
                _vm._g(
                  {
                    key: "export_nist",
                    attrs: {
                      text: "NIST SP 800-53 Security and Privacy Control Coverage",
                      icon: "mdi-file-excel",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.export_nist()
                      },
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Compliance Assessment Audit Tracking Data")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }